// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .preview_image:focus{
    border: 2px solid skyblue;
    } */
    .preview_image .active {
        border: 2px solid skyblue;
        }
    .quantity_number{
        border: none;
    }
    .checkout-product-img-wrapper {
        position: relative;
    }
    .checkout-quantity {
        background: #a2a2a2;
        border: 1px solid #a2a2a2;
        border-radius: 50%;
        -webkit-border-radius: 50%;
        color: #fff;
        height: 25px;
        line-height: 22px;
        position: absolute;
        right: -7px;
        text-align: center;
        top: -7px;
        width: 25px;
    }
    .attribute_css{
        border: 2px solid #0098b8 !important;
        border-radius: 0.4rem;
        font-weight: bold;
    }
    
    .attribute_css.active {
        border-radius: 0.4rem;
        background: #0098b8 !important;
        color: white !important;
        font-weight: bold !important;
    }

    .stock_out{
    text-decoration: line-through;
    background: #dddddd !important;
    border-color: red !important;
    }
    .hide{
        display: none;
    }
    .stock_out:hover + .hide {
        display: block;
    }
    .product_description_section li{
        list-style: disc;
    }

    
    @media screen and (max-width:1024px) {
        .custom-modal .modal-dialog{
            width: 65%;
        }
        .custom-modal .modal-dialog .modal-content{
            height: 85%;
        }
    }
    
    @media screen and (max-width:768px) {
        .custom-modal .modal-dialog{
            width: 65%;
        }
        .custom-modal .modal-dialog .modal-content{
            height: 65%;
        }
    }

    @media screen and (max-width:426px) {
        .custom-modal .modal-dialog{
            width: 95%;
        }
        .custom-modal .modal-dialog .modal-content{
            height: 65%;
        }
    }
    /* @media screen and (max-width:1024px) {
        
    } */`, "",{"version":3,"sources":["webpack://./src/assets/Css/productDetails.css"],"names":[],"mappings":"AAAA;;OAEO;IACH;QACI,yBAAyB;QACzB;IACJ;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,mBAAmB;QACnB,yBAAyB;QACzB,kBAAkB;QAClB,0BAA0B;QAC1B,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,WAAW;QACX,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;IACA;QACI,oCAAoC;QACpC,qBAAqB;QACrB,iBAAiB;IACrB;;IAEA;QACI,qBAAqB;QACrB,8BAA8B;QAC9B,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;IACA,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;IACA;QACI,gBAAgB;IACpB;;;IAGA;QACI;YACI,UAAU;QACd;QACA;YACI,WAAW;QACf;IACJ;;IAEA;QACI;YACI,UAAU;QACd;QACA;YACI,WAAW;QACf;IACJ;;IAEA;QACI;YACI,UAAU;QACd;QACA;YACI,WAAW;QACf;IACJ;IACA;;OAEG","sourcesContent":["/* .preview_image:focus{\n    border: 2px solid skyblue;\n    } */\n    .preview_image .active {\n        border: 2px solid skyblue;\n        }\n    .quantity_number{\n        border: none;\n    }\n    .checkout-product-img-wrapper {\n        position: relative;\n    }\n    .checkout-quantity {\n        background: #a2a2a2;\n        border: 1px solid #a2a2a2;\n        border-radius: 50%;\n        -webkit-border-radius: 50%;\n        color: #fff;\n        height: 25px;\n        line-height: 22px;\n        position: absolute;\n        right: -7px;\n        text-align: center;\n        top: -7px;\n        width: 25px;\n    }\n    .attribute_css{\n        border: 2px solid #0098b8 !important;\n        border-radius: 0.4rem;\n        font-weight: bold;\n    }\n    \n    .attribute_css.active {\n        border-radius: 0.4rem;\n        background: #0098b8 !important;\n        color: white !important;\n        font-weight: bold !important;\n    }\n\n    .stock_out{\n    text-decoration: line-through;\n    background: #dddddd !important;\n    border-color: red !important;\n    }\n    .hide{\n        display: none;\n    }\n    .stock_out:hover + .hide {\n        display: block;\n    }\n    .product_description_section li{\n        list-style: disc;\n    }\n\n    \n    @media screen and (max-width:1024px) {\n        .custom-modal .modal-dialog{\n            width: 65%;\n        }\n        .custom-modal .modal-dialog .modal-content{\n            height: 85%;\n        }\n    }\n    \n    @media screen and (max-width:768px) {\n        .custom-modal .modal-dialog{\n            width: 65%;\n        }\n        .custom-modal .modal-dialog .modal-content{\n            height: 65%;\n        }\n    }\n\n    @media screen and (max-width:426px) {\n        .custom-modal .modal-dialog{\n            width: 95%;\n        }\n        .custom-modal .modal-dialog .modal-content{\n            height: 65%;\n        }\n    }\n    /* @media screen and (max-width:1024px) {\n        \n    } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
